import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const authAxios = () => {
  const token = localStorage.getItem('ob_admin_token');
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const AuthProvider = ({ children }) => {
  // null = checking, false = logged out, object = admin
  const [admin, setAdmin] = useState(null);

  const checkSession = useCallback(async () => {
    const token = localStorage.getItem('ob_admin_token');
    if (!token) {
      setAdmin(false);
      return;
    }
    try {
      const { data } = await authAxios().get('/auth/me');
      setAdmin(data);
    } catch {
      localStorage.removeItem('ob_admin_token');
      setAdmin(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem('ob_admin_token', data.token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('ob_admin_token');
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
